import { IDeserialize } from "./abstraction/IDeserialize";
import { DepartmentFilterType } from "./DepartmentFilterType";

export class Department implements IDeserialize<Department> {
  public name?: string;
  public fullName?: string;

  // Client-side only
  public departmentFilterType: DepartmentFilterType;

  constructor(name?: string, fullName?: string, departmentFilterType?: DepartmentFilterType) {
    this.name = name;
    this.fullName = fullName;
    this.setDeparmentFilterType(departmentFilterType);
  }

  deserialize(model: Department): this {
    if (!model) return this;
    Object.assign(this, model);
    this.setDeparmentFilterType(model.departmentFilterType);
    return this;
  }

  private setDeparmentFilterType(departmentFilterType?: DepartmentFilterType) {
    if (departmentFilterType !== DepartmentFilterType.AllDepartments) {
      this.departmentFilterType = this.name
        ? DepartmentFilterType.Department
        : DepartmentFilterType.NoDepartment;
    } else {
      this.departmentFilterType = DepartmentFilterType.AllDepartments;
    }
  }
}
